import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=9e1e4836&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"
import style0 from "./loading.vue?vue&type=style&index=0&id=9e1e4836&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1e4836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e1e4836')) {
      api.createRecord('9e1e4836', component.options)
    } else {
      api.reload('9e1e4836', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=9e1e4836&scoped=true", function () {
      api.rerender('9e1e4836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/answer/loading.vue"
export default component.exports